// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4x-0";
export var eligibilityCardNotEligible = "_4x-1";